export const lang = {
  //common
  cancel: '取消',
  confirm: '确认',

  //files
  deletemessage: '记录删除成功',
  TVURecordingService: '云录制服务',
  language: '语言设置',
  theme: '主题',
  logout: '退出登录',
  light:  '明亮',
  dark:   '暗黑',
  name: '名称',
  owner: '所有者',
  updateTime: '更新时间',
  startTime: '开始时间',
  endTime: '结束时间',
  fileSize: '近似大小',
  empty: '空',
  recordedFile: '录制文件',
  remoteRecordedFile: '远程录制文件',

  download: '下载',
  searchSession: '名称',
  downloadTipTitle: '转码结束后将自动下载',
  downloadTipContent:
    '请等待一会，系统将在转码后自动下载。在此期间请勿关闭页面。',
  dontShow: '不再提醒',
  gotIt: '好的，开始转码',
  Transcoding: '下载中...',
  selectTimeRange: '请选择时间范围',
  selectTimeRangeError1: '请在',
  selectTimeRangeError2: ' 至 ',
  selectTimeRangeError3: '段内选择需要下载的片段',
  startDownload: '开始下载',
  downloadTips: '请等待一会，系统将在转码结束后自动下载。',
  deleteFile: '删除文件夹',
  deleteMarkerFile: '删除文件？',
  deleteFileConfirm: '确定要删除此文件夹吗？所有内容删除后无法恢复',
  deleteMarkerFileConfirm: '您确定要删除此文件吗？',

  delete: '删除',
  downloadFail: '下载失败，请刷新页面并重试',
  markerFile: '标记文件',
  remoteRecordFile: '远程记录文件',
  multiDeleteHeading: '删除该项',
  multiDeleteContent: '您是否确认删除该项,删除后无法恢复',
  //server
  serverFailed: '请求失败，请重试',
  timeOut: '请求超时，请重试',
  action: '行動',
  clippping: '剪裁',
  tvuSearch: '電視搜索',
  error: '出错了，请刷新页面重试',
  //公共提示代码
  810000014: '出错了，请刷新页面重试',
  81000006: '出错了，请刷新页面重试',
  // 81000017: '抱歉，录音删除失败。',
  81000017: '抱歉，正在录制文件不支持删除',
  81000001: '请登录后使用',
  81000002: '出错了，请刷新页面重试',
  81000003: '出错了，请刷新页面重试',
  810000015: '抱歉，正在录制的文件无法删除',
};
